import { updateBusinessOperation } from "../../../../actions/Utilities/BusinessOperation";
import { useMutation } from "react-query";

const useUpdateBusinessOperation = () => {
  return useMutation(updateBusinessOperation);
};
export default useUpdateBusinessOperation;
